import React from 'react'
import accountimg from '../../images/contact 1.png'
import checkmark from '../../images/checkmark (1) 1.png'
import { Link, useNavigate } from 'react-router-dom'
import img from '../../images/image 2.png'
import img2 from '../../images/Untitled-1 1.png'
const ProductCards = () => {
  const navigate = useNavigate()
  return (
    <>

      <div className='product_cards_wrapper ' style={{
        position: 'relative'
      }}>
        <img src={img} style={{
          width: '250px',
          position: "absolute",
          top: '18.2%',
          left: "-144px"
        }} />

        <img src={img2} style={{
          width: '250px',
          position: "absolute",
          bottom: '0.2%',
          right: "-20%"
        }} />

        {['Business', 'Investor', 'Personal', 'Bookkeeper'].map((e, i) => {
          return (
            <>
              <div className='product_card'>
                <div className='account_img_div_wrapper'>
                  <img src={accountimg} />
                  <p>{e}</p>
                </div>
                <div className='product_tabs_wrapper'>
                  <div style={e === 'Business' ? { background: '#0c2637',border:'1px solid #fff',color:'#fff' } : {}}>Business</div>
                  <div style={e === 'Personal' ? { background: '#0c2637',border:'1px solid #fff',color:'#fff' } : {}}>Personal</div>
                  <div style={e === 'Bookkeeper' ? { background: '#0c2637',border:'1px solid #fff',color:'#fff' } : {}}>Bookkeeper</div>
                  <div style={e === 'Investor' ? { background: '#0c2637',border:'1px solid #fff',color:'#fff' } : {}}>Investor</div>
                </div>
                <Link
                  to={e === 'Business' ? 'https://fisibility.navattic.com/da102wd' : e === "Investor" ? 'https://fisibility.navattic.com/k890mcu' : e === 'Personal' ? 'https://fisibility.navattic.com/x2a0u9a' : e === 'Bookkeeper' ? 'https://fisibility.navattic.com/qq40ckx' : ''}

                  // to={e=== 'Business' ? '/login' : e==="Investor" ? '/login' : e === 'Personal' ? '/login':e=== 'Bookkeeper' ? '/login':''} 
                  className='start_btn'>Start <img style={{
                    width: '20px',
                  }} src={checkmark} /> </Link>
              </div>
            </>
          )
        })}


      </div>
    </>
  )
}

export default ProductCards
